/**
 * x_tarificador-cart-rates-ui.js
 * Actualización de interfaz de usuario (header button, formateo)
 */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Actualiza el botón del header con la ubicación seleccionada
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton = () => {
    const headerBtn = document.getElementById('shippingLocationValue');
    if (!headerBtn) return;
    
    const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect') || document.getElementById('popupProvinceSelect');
    const citySelect = document.getElementById('pscCartDropdownCitySelect') || document.getElementById('popupCitySelect');
    
    const pinIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 4px;">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
    </svg>`;
    
    let cityName = null;

    // NUEVO: Verificar si hay un cliente logueado con dirección
    if (window.customerAddress && window.customerAddress.city) {
      cityName = window.customerAddress.city;
      headerBtn.innerHTML = `${pinIcon}<span>Enviar a ${cityName}</span>`;
      return;
    }

    // Intentar obtener de los selectores actuales
    if (provinceSelect && citySelect && citySelect.value && citySelect.value !== '0') {
      cityName = citySelect.options[citySelect.selectedIndex].text;
    }
    
    // Si no se encontró, cargar desde localStorage
    if (!cityName) {
      const savedSelection = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.loadSelection();
      if (savedSelection.city) {
        cityName = savedSelection.city;
      }
    }

    // Actualizar contenido del botón
    headerBtn.innerHTML = cityName 
      ? `${pinIcon}<span>Enviar a ${cityName}</span>`
      : `${pinIcon}<span>Selecciona tu ubicación</span>`;
  };

  /**
   * Formatea un número como moneda chilena
   * @param {number|string} amount - Monto a formatear
   * @returns {string} Monto formateado
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.numberformat = (amount) => {
    amount += '';
    amount = parseFloat(amount.replace(/[^0-9\.]/g, ''));
    const decimals = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.decimalValues || 0;
    
    if (isNaN(amount) || amount === 0) {
      return parseFloat(0).toFixed(decimals);
    }
    
    amount = '' + amount.toFixed(decimals);
    const amount_parts = amount.split('.');
    const regexp = /(\d+)(\d{3})/;
    
    while (regexp.test(amount_parts[0])) {
      amount_parts[0] = amount_parts[0].replace(regexp, '$1' + '.' + '$2');
    }
    
    return amount_parts.join('.');
  };
})();